import React, { useRef, useState } from 'react'
import './TemplateDetailsBox.scss'
import { Modal } from '../../../components/Modal/Modal'
import { LexicalEditor } from 'lexical'
import { WritableLexicalEditor } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/WritableLexicalEditor/WritableLexicalEditor'
import { RichTextToolbarPlugin } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Plugins/RichTextToolbarPlugin/RichTextToolbarPlugin'
import { LEXICAL_NODES } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'
import { getEditorHtmlContent } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'
import { Modal as BootstrapModal } from 'react-bootstrap'

interface AddSampleModalProps {
  show: boolean
  onCancel: () => void
  onAddSample: (sample: string) => void
  initialValue?: string
}

export const AddSampleModal: React.FC<AddSampleModalProps> = ({ show, onCancel, onAddSample, initialValue }) => {
  const editorRef = useRef<LexicalEditor>(null)
  const [hasContent, setHasContent] = useState(!!initialValue)

  const handleAddSample = () => {
    const editor = editorRef.current
    if (!editor) {
      return
    }
    const html = getEditorHtmlContent(editor.getEditorState())
    if (!html) {
      return
    }
    onAddSample(html)
  }

  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={
        <BootstrapModal.Title>
          <div className='ps-2'>Add sample</div>
        </BootstrapModal.Title>
      }
      headerBodySeparator={false}
      body={
        <div className='d-flex flex-column gap-4'>
          <p className='paragraph-medium zocks-text-gray-900 mb-0'>Paste existing meeting notes. Your AI Assistant will use it to generate this template.</p>
          <WritableLexicalEditor
            key={initialValue ?? 'empty'}
            ref={editorRef}
            className='border rounded-3 zocks-border-color-gray-300'
            containerClassName='w-100'
            editorContainerClassName='px-3 py-2 overflow-y-auto template-sample-editor'
            lexicalNodes={LEXICAL_NODES}
            placeholder={<span className='paragraph-medium zocks-text-gray-600'>Paste your sample here...</span>}
            header={<RichTextToolbarPlugin className='p-2 gap-2 border-bottom zocks-border-color-gray-300' />}
            initialHtmlValue={initialValue}
            onChange={(editorState) => setHasContent(!editorState.isEmpty())}
          />
        </div>
      }
      showFooterActions
      footerPrimaryActionTitle='Add sample'
      footerPrimaryActionDisabled={!hasContent}
      onFooterPrimaryAction={handleAddSample}
      onFooterSecondaryAction={onCancel}
      centered
      size='lg'
    />
  )
}
